import { UrlProvider } from 'urls'

import routeWithLayout from 'components/auth/routeWithLayout'

import Companies from '../views/company/Companies'
import Company from '../views/company/Company'

export default [
  routeWithLayout({ main: Companies, path: UrlProvider.getRawUrl('companies') }),
  routeWithLayout({ main: Company, path: UrlProvider.getRawUrl('company') }),
]
